import { motion } from "framer-motion";

export function Leaf({ className = "", color = "#1B3B28" }) {
  return (
    <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
      <path
        d="M50 95 C20 70 8 40 18 12 C46 18 62 46 50 95 Z"
        stroke={color}
        strokeWidth="1.4"
        fill="none"
      />
      <path d="M50 95 C44 62 36 38 18 12" stroke={color} strokeWidth="1" />
      <path d="M46 78 C38 74 30 74 24 76 M45 62 C37 58 30 58 25 60 M43 46 C36 43 31 43 27 45 M38 32 C33 30 29 30 26 31"
        stroke={color} strokeWidth="0.8" />
    </svg>
  );
}

export function Vine({ className = "", color = "#8EA696", flip = false }) {
  return (
    <svg
      viewBox="0 0 60 400"
      fill="none"
      className={className}
      style={flip ? { transform: "scaleX(-1)" } : undefined}
      aria-hidden="true"
    >
      <path
        d="M30 0 C10 60 50 100 30 160 C10 220 50 260 30 320 C20 355 26 380 30 400"
        stroke={color}
        strokeWidth="1.3"
      />
      {[
        [30, 55, -1], [32, 115, 1], [28, 175, -1], [33, 235, 1], [29, 295, -1], [31, 350, 1],
      ].map(([x, y, d], i) => (
        <g key={i} transform={`translate(${x} ${y}) rotate(${d * 35})`}>
          <path d="M0 0 C14 -8 24 -4 30 6 C18 12 6 10 0 0 Z" stroke={color} strokeWidth="1" fill="none" />
        </g>
      ))}
    </svg>
  );
}

export function FloatLeaf({ className = "", delay = 0, color = "#1B3B28" }) {
  return (
    <motion.div
      className={`absolute pointer-events-none ${className}`}
      animate={{ y: [0, -14, 0], rotate: [0, 3, 0] }}
      transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay }}
    >
      <Leaf className="w-full h-full" color={color} />
    </motion.div>
  );
}
